import React from 'react';
import SectionCard from '../../../common_components/SectionCard';
import '../../../styles/mobile/Home.scss';
import CmykTopBar from '../../../common_components/design_components/CmykTopBar';
import FooterMobile from "../../../common_components/FooterMobile";

const HomeMobile = () => {
  return (
    <div className="homepage-mobile">
        <div className="cmyk-top-container">
            <CmykTopBar/>
        </div>
        <div className="layout-container">
            <div className="sections-mobile"> 
                <SectionCard
                title="JACOB RULEAUX"
                description="Designer, developer, adventurer—always exploring new possibilities.
                I’ve traveled far, lived abroad, and find joy in connecting with people,
                seeking out nature’s beauty, and problem-solving."
                className="about"
                to="/about" 
                />
                <SectionCard
                title="ILLUSTRATIONS"
                description="Inspired by nature and history, my illustrations blend tradition and technology. Whether using paper or digital tools, the process is deeply absorbing—a meditative escape."
                className="illustrations"
                to="/illustrations" 
                />
                <SectionCard
                title="CONTACT"
                description="Drop me a line! Have an idea or question? Let's make something great together—shoot me a note and let's chat!"
                className="contact"
                to="/contact"
                />
                {/* Print Projects */}
                <SectionCard
                title="PRINT PROJECTS"
                description="From business cards to billboards, I've designed it all. My print portfolio spans brochures, stickers, magazines, and signage—every project gets the same attention to detail."
                className="print-projects"
                to="/print-projects"
                />
                {/* Digital Projects */}
                <SectionCard
                title="DIGITAL PROJECTS"
                description="I've done it all—digital ads, social posts, web design, and webmaster duties. I bring creativity and technical know-how to make the digital world look seamless and functional."
                className="digital-projects"
                to="/digital-projects"
                />
            </div>
        </div>
        <FooterMobile />
    </div>
  );
};

export default HomeMobile;
